import { render, staticRenderFns } from "./AnswerCell.vue?vue&type=template&id=946fe7d0&scoped=true&"
import script from "./AnswerCell.vue?vue&type=script&lang=js&"
export * from "./AnswerCell.vue?vue&type=script&lang=js&"
import style0 from "./AnswerCell.vue?vue&type=style&index=0&id=946fe7d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946fe7d0",
  null
  
)

export default component.exports